/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '../../../application';

import { getAgent } from './agent';

const is = require('is_js');

const SERVICE_NAME = 'OrganizationService';

export class OrganizationPageService {
  private static instance: OrganizationPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): OrganizationPageService {
    if (!OrganizationPageService.instance) {
      OrganizationPageService.instance = new OrganizationPageService(props);
    }
    return OrganizationPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Header Props
    compProps = await agent.getHeaderProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    // //Main Props
    // compProps = await agent.getMainSectionProps({});
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }

    //Feature Section Props
    compProps = await agent.getFeatureSectionProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Footer Props
    compProps = await agent.getFooterProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async updateProfile(args: any) {
    console.log(`profile data in service:`, args);
    const agent = getAgent();
    return agent?.getUpdateProfile(args);
  }
}
